
export const SamplePage = ({title}) => {
  return (
    <>
      <h1>{title}</h1>
    </>
  )
}
